export default '#375a8c';
